/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImuReadPayload
 */
export interface ImuReadPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: ImuReadPayloadTypeEnum;
    /**
     * 
     */
    acc: Array<number>;
    /**
     * 
     */
    gyr: Array<number>;
    /**
     * 
     */
    roll: number;
    /**
     * 
     */
    pitch: number;
}


/**
 * @export
 */
export const ImuReadPayloadTypeEnum = {
    ImuRead: 'imu_read',
} as const;
export type ImuReadPayloadTypeEnum = typeof ImuReadPayloadTypeEnum[keyof typeof ImuReadPayloadTypeEnum];


/**
 * Check if a given object implements the ImuReadPayload interface.
 */
export function instanceOfImuReadPayload(value: object): value is ImuReadPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'imu_read') return false;
    
    if (!('acc' in value) || value['acc'] === undefined) return false;
    if (!('gyr' in value) || value['gyr'] === undefined) return false;
    if (!('roll' in value) || value['roll'] === undefined) return false;
    if (!('pitch' in value) || value['pitch'] === undefined) return false;
    return true;
}

export function ImuReadPayloadFromJSON(json: any): ImuReadPayload {
    return ImuReadPayloadFromJSONTyped(json, false);
}

export function ImuReadPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImuReadPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'acc': json['acc'],
        'gyr': json['gyr'],
        'roll': json['roll'],
        'pitch': json['pitch'],
    };
}

export function ImuReadPayloadToJSON(json: any): ImuReadPayload {
    return ImuReadPayloadToJSONTyped(json, false);
}

export function ImuReadPayloadToJSONTyped(value?: ImuReadPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'acc': value['acc'],
        'gyr': value['gyr'],
        'roll': value['roll'],
        'pitch': value['pitch'],
    };
}

